import darkAuthMiddleware from "./darkAuthMiddleware";
import lightAuthMiddleware from "./lightAuthMiddleware";

const middleware = process.env.REACT_APP_IS_DARK === 'true' ? darkAuthMiddleware: lightAuthMiddleware;
export default middleware;